import { render } from "./AddMoreDays.html?vue&type=template&id=74885e3d&ts=true&external"
import script from "./AddMoreDays.vue?vue&type=script&lang=ts"
export * from "./AddMoreDays.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__